module.exports = __webpack_public_path__ + "img/a011_6.ecbb99ca.png";